/*
 * @Description:
 * @Date: 2022-04-09 17:12:58
 * @LastEditTime: 2022-04-22 00:21:14
 */
// const b2cPolicies = {
//   names: {
//     signIn: "B2C_1_login",
//     signUp: "B2C_1_singup",
//     resetPassword: "B2C_1A_DISPLAYCONTROL_SENDGRID_PASSWORDRESET",
//   },
//   authorities: {
//     signIn: {
//       authority:
//         "https://lytechb2ctest.b2clogin.com/lytechb2ctest.onmicrosoft.com/B2C_1_login",
//     },
//     signUp: {
//       authority:
//         "https://lytechb2ctest.b2clogin.com/lytechb2ctest.onmicrosoft.com/B2C_1_singup",
//     },
//     resetPassword: {
//       authority:
//         "https://lytechb2ctest.b2clogin.com/lytechb2ctest.onmicrosoft.com/B2C_1A_DISPLAYCONTROL_SENDGRID_PASSWORDRESET",
//     },
//   },
//   authorityDomain: "lytechb2ctest.b2clogin.com",
// };
const b2cPolicies = {
  names: {
    signIn: process.env.VUE_APP_AZURE_LOGIN_POLICY_NAME,
    signUp: process.env.VUE_APP_AZURE_SIGNUP_POLICY_NAME,
    resetPassword: process.env.VUE_APP_AZURE_PASSWORD_RESET_POLICY_NAME,
  },
  authorities: {
    signIn: {
      authority: process.env.VUE_APP_AZURE_LOGIN_POLICY_ENDPOINT,
    },
    signUp: {
      authority: process.env.VUE_APP_AZURE_SIGNUP_POLICY_ENDPOINT,
    },
    resetPassword: {
      authority: process.env.VUE_APP_AZURE_PASSWORD_RESET_POLICY_ENDPOINT,
    },
  },
  authorityDomain: process.env.VUE_APP_AZURE_AUTHORITY_DOMAIN,
};
export { b2cPolicies };
